import { render, staticRenderFns } from "./tab-description.vue?vue&type=template&id=8e1a5a26"
import script from "./tab-description.vue?vue&type=script&lang=js"
export * from "./tab-description.vue?vue&type=script&lang=js"
import style0 from "./tab-description.vue?vue&type=style&index=0&id=8e1a5a26&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports